/* eslint-disable prettier/prettier */
import React from 'react';
import Layout from '@/components/Layout';
import {
  Text,
  Flex,
  Box,
  Container,
  Link as LinkBase,
  Divider,
} from 'theme-ui';
import { graphql, Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import Halo from '@/components/Halo';
import Rings from '@/components/Rings';
// import { DottedPane } from '@/components/Animax';

export interface HomeProps {
  data: any;
}

interface WorkCardProps {
  post: any;
}

/**
 * Team Item
 * @param {*} members
 */

function TeamItem({ node }) {
  // eslint-disable-next-line camelcase
  const { name, position, profile_image } = node;
  return (
    <Box variant="styles.cardBlock">
      <Flex>
        <Box sx={{ width: `25%` }}>
          <GatsbyImage
            // eslint-disable-next-line camelcase
            image={profile_image.asset.gatsbyImageData}
            alt={`Photos of ${name}`}
          />
        </Box>
        <Box mx={4} mt={[0, 1, 5]} sx={{ pt: [2, 0, 0], width: `75%` }}>
          <Text
            as="h4"
            variant="personName"
            sx={{ color: `grays.9`, fontWeight: `bold` }}
          >
            {name}
          </Text>
          <Text variant="personDesc" sx={{ color: `hover` }}>
            {position}
          </Text>
        </Box>
      </Flex>
    </Box>
  );
}

export function WorkCard({ post }: WorkCardProps) {
  return (
    <Box
      sx={{ flex: 0, minWidth: [`100%`, `50%`, `50%`], mb: 6, mt: 3, pr: 4 }}
    >
      <GatsbyImage
        image={post.node.mainImage.profile_image.gatsbyImageData}
        alt="Work "
      />
      <Box pt={3} style={{ position: `relative` }}>
        <Text
          as="p"
          // variant="blockTitle"
          sx={{ color: `grays.8`, fontSize: 1, mb: 2 }}
        >
          Product Design
        </Text>
        <LinkBase
          as={Link}
          variant="blockTitleLink"
          href={`/projects/${post.node.id}`}
        >
          {post.node.title}
        </LinkBase>
      </Box>
    </Box>
  );
}

function AboutPage({ data }: HomeProps) {
  const postEdges = (data && data.profiles && data.profiles.edges) || [];

  return (
    <Layout>
      <Halo
        title="About"
        description="We are a strategic, creative studio based out of Bangalore. Our team works with founders and product teams to ideate, design and build quality digital products and brand experiences."
        url=""
        author=""
        image=""
      />

      <Box
        sx={{
          minHeight: [`70vh`, `73vh`, `73vh`],
          borderBottomColor: `grays.4`,
          maxWidth: [`90vw`, `80vw`, `93vw`],
          marginLeft: [`auto`, `auto`, `auto`],
          marginRight: [`0px`, `0px`, `0.1px`],
          px: [0, 4, 0],
          pt: [6, 0, 7],
          display: `flex`,
          alignItems: `center`,
          justifyContent: `space-between`,
          flexWrap: `wrap`,
          overflow: `hidden`,
        }}
      >
        <Box
          sx={{
            p: 0,
            m: 0,
            mt: -7,
            flex: [`0.7`, `0.5`, `0.5`],
          }}
        >
          <Text
            as="p"
            sx={{
              mb: [0, 4, 4],
              fontSize: `15px`,
              fontWeight: 400,
              color: `grays.8`,
            }}
          >
            About
          </Text>
          <Text
            as="p"
            variant="pageDesc"
            sx={{ mb: 4, fontSize: 1, fontWeight: 300, color: `grays.8` }}
          >
            We are a strategic, creative studio based out of Bangalore. Our team
            works with founders and product teams to ideate, design and build
            quality digital products and brand experiences.
          </Text>
        </Box>
        <Box
          sx={{
            flex: 0.7,
            overflow: `hidden`,
            height: `73vh`,
            position: [`absolute`, `relative`, `relative`],
            maxWidth: `89vw`,
            // '@media screen and (max-width: 720px)': {
            //   position: `absolute`,
            //   top: `-2vh`,
            // },
          }}
        >
          <Rings />
        </Box>
      </Box>

      <Container sx={{ p: [0, `auto`, `auto`] }}>
        <Box variant="styles.pageFrame" sx={{ paddingTop: `0px !important` }}>
          {/* <Flex sx={{ alignItems: `center`, justifyContent: `center` }}>
            <Divider sx={{ flex: 1, color: `grays.1` }} />
            <Box
              sx={{
                mb: 3,
                // bg: `grays.2`,
                maxWidth: [`414px`],
                height: [`auto`],
                // border: `solid 1px`,
                backgroundColor: `grays.1`,
                flex: `auto`,
                padding: `35px`,
              }}
            >
              <Text
                as="h2"
                sx={{ color: `grays.8`, fontWeight: `700`, fontSize: 1, mb: 2 }}
              >
                What’s with the name?
              </Text>
              <Text
                as="p"
                sx={{ fontSize: 0, fontWeight: `400`, color: `grays.6` }}
              >
                Our name reflects our quest.
                <br /> We work at the intersection of <br />
                &quot;Form&quot; & &quot;Function&quot;.
              </Text>
            </Box>
          </Flex> */}
          <Divider
            sx={{
              color: `Dcolor`,
              maxWidth: [`90vw`, `80vw`, `85vw`],
              marginLeft: `auto`,
              marginRight: `auto`,
            }}
          />
          <Box variant="styles.bodyFrame2" sx={{ py: 3, ml: 0, mt: 6 }}>
            {/* <Text as="h3" variant="blockTitle" sx={{ py: 2 }}>
              Our Team
            </Text> */}
            {/* <Box sx={{ maxWidth: `80ch` }}>
              <Text as="h1" sx={{ fontWeight: `700`, fontSize: 3 }}>
                Who we really are
              </Text>
              <Text
                as="p"
                // variant="pageDesc"
                sx={{
                  mb: `95px`,
                  fontSize: 2,
                  fontWeight: 300,
                  color: `Stext`,
                }}
              >
                Under the hood, we are a bunch of humans.
              </Text>
            </Box> */}
            <Flex sx={{ flexWrap: `wrap`, mt: 3 }}>
              {postEdges &&
                postEdges.map((dep: any) => (
                  <Flex
                    sx={{
                      mb: 3,
                      flexWrap: `wrap`,
                      width: [`100%`, `100%`, `50%`],
                    }}
                  >
                    <TeamItem {...dep} />
                  </Flex>
                ))}
            </Flex>
          </Box>
        </Box>

        {/* <Box sx={{ py: 5 }}>
            <Text as="h1" variant="pageTitle">
              Join Our Team
            </Text>
            <Text as="h2">If you are intrested in joining our team?</Text>
            <Text>View our open positions</Text>
          </Box> */}
      </Container>
    </Layout>
  );
}

export default AboutPage;

export const query = graphql`
  query TeamPageQuery {
    profiles: allSanityPerson {
      edges {
        node {
          id
          name
          profile_image {
            asset {
              gatsbyImageData(
                fit: FILLMAX
                placeholder: BLURRED
                width: 400
                height: 400
              )
            }
          }
          position
        }
      }
    }
  }
`;
